export default __webpack_public_path__ + "static/media/carousel-4.ce81702d.jpg";